export const DATE_FORMAT = 'yyyy.LL.dd';
export const TIME_FORMAT = `HH:mm`;

export const KeyCode = {
  ENTER: 13,
  UP: 38,
  DOWN: 40,
};
